import { render } from "./NextCourseDetermination.vue?vue&type=template&id=1618126d&scoped=true"
import script from "./NextCourseDetermination.vue?vue&type=script&lang=js"
export * from "./NextCourseDetermination.vue?vue&type=script&lang=js"

import "./NextCourseDetermination.vue?vue&type=style&index=0&id=1618126d&scoped=true&lang=css"

import exportComponent from "/home/hohte/projects/lms/frontend/production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1618126d"]])

export default __exports__